export enum EReligion {
  Islam = 1,
  Protestant = 2,
  Catholicism = 3,
  Hinduism = 4,
  Buddhism = 5,
  Confucianism = 6,
  BeliefInOneSupremeGod = 7,
}

export const EReligionLabel = {
  [EReligion.Islam]: 'Islam',
  [EReligion.Protestant]: 'Kristen',
  [EReligion.Catholicism]: 'Katolik',
  [EReligion.Hinduism]: 'Hindu',
  [EReligion.Buddhism]: 'Buddha',
  [EReligion.Confucianism]: 'Konghucu',
  [EReligion.BeliefInOneSupremeGod]: 'Kepercayaan Terhadap Tuhan YME',
};
